import { render, staticRenderFns } from "./single-file-upload.vue?vue&type=template&id=067b004e&"
import script from "./single-file-upload.vue?vue&type=script&lang=ts&"
export * from "./single-file-upload.vue?vue&type=script&lang=ts&"
import style0 from "./single-file-upload.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports